(function ($) {
    if ($('.diagonal-content-block').length) {
        const gallerySwiper = new Swiper('.diagonal-content-block .gallery-swiper', {
            // spaceBetween: 10,
            autoHeight: true,
            // hashNavigation: {
            //     watchState: true
            // },
            keyboard: {
                enabled: true,
                onlyInViewport:true,
            },
            loop: true,
            pagination: {
                el: '.swiper-pagination',
                type: 'fraction',
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
        });

        if (window.location.hash.includes("gallery-top")) {
            $('body').addClass('overflow-hidden');
            $('body').addClass('modal-open');
            $('.gallery-modal.top').addClass('active');
        }
        if (window.location.hash.includes("gallery-bottom")) {
            $('body').addClass('overflow-hidden');
            $('body').addClass('modal-open');
            $('.gallery-modal.bottom').addClass('active');

        }

        $(window).on('hashchange', function() {
            if (!window.location.hash) {
                $('.gallery-modal.top').removeClass('active');
                $('.gallery-modal.bottom').removeClass('active');
                $('body').removeClass('overflow-hidden');
                $('body').removeClass('modal-open');
            } else {
                if (window.location.hash.includes("gallery-top")) {
                    const targetGallery = window.location.hash.split('gallery-top-')[1];
                    if(targetGallery){
                        // gallerySwiper.slideTo($(gallerySwiper.slides).filter(`[data-gallery=${targetGallery}]`).index(), 0);
                        window.location.hash = `gallery-top-${targetGallery}`;
                        $('.gallery-modal.top').addClass('active');
                        $('body').addClass('overflow-hidden');
                        $('body').addClass('modal-open');
                    }
                }else {

                    const targetGallery = window.location.hash.split('gallery-bottom-')[1];

                    if (targetGallery) {
                        // gallerySwiper.slideTo($(gallerySwiper.slides).filter(`[data-gallery=${targetGallery}]`).index(), 0);
                        window.location.hash = `gallery-bottom-${targetGallery}`;
                        $('.gallery-modal.bottom').addClass('active');
                        $('body').addClass('overflow-hidden');
                        $('body').addClass('modal-open');
                    }
                }

            }
        })
        $('body').on('click', '.open-gallery-modal', function() {
            const targetgallery = $(this).data('gallery');
            const targetgalleryposition = $(this).data('gallery-position');
            if(targetgalleryposition == 'gallery-top') {
                $('.gallery-modal.top').addClass('active');
                $('body').addClass('overflow-hidden');
                $('body').addClass('modal-open');
                window.location.hash = `${targetgallery}`;
            }else {
                $('.gallery-modal.bottom').addClass('active');
                $('body').addClass('overflow-hidden');
                $('body').addClass('modal-open');
                window.location.hash = `${targetgallery}`;
            }
        })

        $('.gallery-modal .close-button').on('click', function() {
            $('.gallery-modal').removeClass('active');
            $('body').removeClass('overflow-hidden');
            $('body').removeClass('modal-open');
            window.history.pushState('', '/', window.location.pathname)
        })
        $(document).on('keyup',function(evt) {
            if (evt.keyCode === 27) {
                $('.gallery-modal').removeClass('active');
                $('body').removeClass('overflow-hidden');
                $('body').removeClass('modal-open');
                window.history.pushState('', '/', window.location.pathname)
            }
        });
    }

    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);




})(jQuery);